import { z } from 'zod';

import {
  SimphonyMenuDetailSchema,
  SimphonyMenuSummarySchema,
  SimphonyRevenueCenterSchema,
  SimphonyTenderCollectionSchema,
} from './schemas';
import { buildQueryString } from '../../utils/querystring';
import { makeEndpoint } from '../common';

const GetBrandRevenueCentersResponseSchema = z.object({
  count: z.number(),
  limit: z.number(),
  offset: z.number(),
  items: z.array(SimphonyRevenueCenterSchema),
});

export const GetBrandRevenueCentersEndpoint = makeEndpoint({
  method: 'GET',
  url: ({ query }) => `v1/simphony/revenue-centers?${buildQueryString(query)}`,
  requestSchema: z.void(),
  querySchema: z.object({
    brandId: z.string(),
  }),
  responseSchema: GetBrandRevenueCentersResponseSchema,
});

const QuerySchema = z.object({
  rvcRef: z.string(),
  brandId: z.string(),
});

export const GetBrandMenuSummaryEndpoint = makeEndpoint({
  method: 'GET',
  url: ({ query }) => `v1/simphony/menu/summary?${buildQueryString(query)}`,
  requestSchema: z.void(),
  querySchema: QuerySchema,
  responseSchema: SimphonyMenuSummarySchema,
});

export const GetBrandMenuEndpoint = makeEndpoint({
  method: 'GET',
  url: ({ query }) => `v1/simphony/menu?${buildQueryString(query)}`,
  requestSchema: z.void(),
  querySchema: QuerySchema,
  responseSchema: SimphonyMenuDetailSchema,
});

export const GetBrandTendersCollectionEndpoint = makeEndpoint({
  method: 'GET',
  url: ({ query }) => `v1/simphony/tenders/collection?${buildQueryString(query)}`,
  requestSchema: z.void(),
  querySchema: QuerySchema,
  responseSchema: SimphonyTenderCollectionSchema,
});

export const GetBrandStatusEndpoint = makeEndpoint({
  method: 'GET',
  url: ({ query }) => `v1/simphony/status?${buildQueryString(query)}`,
  requestSchema: z.void(),
  querySchema: z.object({
    brandId: z.string(),
  }),
  responseSchema: z.object({
    status: z.boolean(),
  }),
});
